module.exports = __webpack_public_path__ + "img/racecourse-kenilworth-turf-winter-1700.d98d2002.svg";